import React from "react";
import RanksProLogo from "../../../Assets/site-audit/RanksProLogo.png";
import AddProjectStore from "../../../../store/AddProjectStore";

const PdfModalImage = () => {
  const { appliedWhiteLable } = AddProjectStore((state) => state);
  return (
    <div
      style={{ width: "100%", height: "180px" }}
      className="pg-2 d-flex justify-content-center align-items-center flex-column"
    >
      <img
        src={appliedWhiteLable?.header_logo || RanksProLogo}
        alt="brand-logo"
        style={{ width: "300px", height: "100px", objectFit: "contain" }}
      />
    </div>
  );
};

export default PdfModalImage;
